import { useMutation } from '@apollo/client'
import {
  GenerateNewInvoiceVariables,
  GenerateNewInvoice
} from '../../types'
import { GENERATE_NEWEVENTINVOICE } from './operations'

export const useGenerateNewEventInvoice = () => useMutation<
  GenerateNewInvoice,
  GenerateNewInvoiceVariables
>(GENERATE_NEWEVENTINVOICE)
